<div #wrapper class="linechart-wrapper" [id]="controlUid"></div>
